<template>
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form id="condition-form"
                autocomplete="new-password"
                @submit.stop.prevent="handleSubmit(saveEditData)"
                @reset="resetForm"
        >
            <dl class="description-list-wrapper">
                <DescriptionItem :label="$t('조건명')" mode="form" labelFor="edit-form-condition-name"
                                 required
                >
                    <div class="w-100">
                        <validation-provider
                            v-slot="validationContext"
                            name="edit-form-condition-name"
                            :rules="{ required: true, min: 2 }"
                        >
                            <b-form-input id="edit-form-condition-name"
                                          v-model="form.name"
                                          name="edit-form-condition-name"
                                          :disabled="editLoading"
                                          :placeholder="$t('조건명')"
                                          :state="getValidationState(validationContext)"
                                          autocomplete="new-password"
                                          aria-describedby="edit-form-condition-name-feedback"
                            />
                            <b-form-invalid-feedback id="edit-form-condition-name-feedback">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </validation-provider>
                    </div>
                </DescriptionItem>
                <DescriptionItem :label="$t('조건 키')" mode="form" labelFor="edit-form-condition-key"
                                 required
                >
                    <div class="w-100">
                        <validation-provider
                            v-slot="validationContext"
                            name="edit-form-condition-key"
                            :rules="{ required: true }"
                        >
                            <b-form-input id="edit-form-condition-key"
                                          v-model="form.key"
                                          name="edit-form-condition-key"
                                          :disabled="editLoading"
                                          :placeholder="$t('조건 키')"
                                          :state="getValidationState(validationContext)"
                                          autocomplete="new-password"
                                          aria-describedby="edit-form-condition-key-feedback"
                            />
                            <b-form-invalid-feedback id="edit-form-condition-key-feedback">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </validation-provider>
                    </div>
                </DescriptionItem>

                <DescriptionItem :label="$t('연산자')" mode="form" labelFor="edit-form-operator" required>
                    <validation-provider
                        v-slot="validationContext"
                        name="edit-form-operator"
                        class="w-100"
                        :rules="{ required: true }"
                    >
                        <b-form-select id="edit-form-operator"
                                       v-model="form.operator"
                                       :disabled="editLoading"
                                       autocomplete="new-password"
                                       :state="getValidationState(validationContext)"
                                       aria-describedby="edit-form-operator-feedback"
                                       name="edit-form-operator"
                                       :options="operatorOptions"

                        />
                        <b-form-invalid-feedback id="edit-form-operator-feedback">
                            {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                    </validation-provider>
                </DescriptionItem>

                <DescriptionItem :label="$t('값')" mode="form" labelFor="edit-form-value"
                                 required
                >
                    <div class="w-100">
                        <validation-provider
                            v-slot="validationContext"
                            name="edit-form-value"
                            :rules="{ required: true }"
                        >
                            <b-form-input id="edit-form-value"
                                          v-model="form.value"
                                          name="edit-form-value"
                                          :disabled="editLoading"
                                          :placeholder="$t('값 (JSON 또는 단일 값)')"
                                          :state="getValidationState(validationContext)"
                                          autocomplete="new-password"
                                          aria-describedby="edit-form-value-feedback"
                            />
                            <b-form-invalid-feedback id="edit-form-value-feedback">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </validation-provider>
                    </div>
                </DescriptionItem>

                <DescriptionItem :label="$t('설명')" mode="form" labelFor="edit-form-description">
                    <b-form-textarea id="edit-form-description"
                                     v-model="form.description"
                                     :disabled="editLoading"
                                     :placeholder="$t('설명 (선택사항)')"
                                     autocomplete="new-password"
                    />
                </DescriptionItem>


                <div v-if="mode === 'edit'" class="row-wrapper">
                    <DescriptionItem :label="$t('등록일시')">
                        {{ get_date(detailData.created_at) || '-' }}
                    </DescriptionItem>

                    <DescriptionItem :label="$t('수정일시')">
                        {{ get_date(detailData.updated_at) || '-' }}
                    </DescriptionItem>
                </div>
            </dl>
        </b-form>
    </validation-observer>
</template>

<script>
import {createCondition, updateCondition} from '@shared_utils/api/ruleEngine';
import DescriptionItem from '@shared/components/common/DescriptionItem.vue';
import {operatorOptions} from '@shared/components/admin/pages/Management/CampaignConnectRule/Condition/data';
import {getDate} from '@shared/utils/common';

export default {
    name: 'ConditionForm',
    components: {
        DescriptionItem,
    },
    props: {
        detailData: {
            type: [Object, null],
            default: null,
        },
        mode: {
            type: String,
            required: true,
            default: 'add', // add | edit
        }
    },

    data() {
        return {
            editLoading: false,
            form: {
                name: null,
                key: null,
                description: null,
                operator: null,
                value: null,
            },
        };
    },
    computed: {
        operatorOptions() {
            return operatorOptions;
        },
        get_date() {
            return (date) => {
                return getDate(date);
            };
        }
    },
    watch: {
        detailData: {
            immediate: true,
            handler() {
                this.form = {...this.form, ...this.detailData};
            }
        }
    },
    methods: {
        getValidationState({dirty, validated, valid = null}) {
            return dirty || validated ? valid : null;
        },
        async saveEditData() {
            try {
                this.editLoading = true;

                let response = null;
                const form = {...this.form};
                if(this.mode === 'add'){
                    response =  await createCondition(form);
                }
                else if (this.mode === 'edit'){
                    response =  await updateCondition(this.detailData.id, form);
                }

                this.$EventBus.$emit('toast-success', this.$t('조건 등록 및 수정'), this.$t('조건이 성공적으로 저장되었습니다.'));
                this.$emit('updateDetailData', {...this.detailData, ...this.form, ...response.data});
            } catch (error) {
                console.error(error);
                console.dir(error);
                this.$EventBus.$emit('toast-failure', this.$t('조건 등록 및 수정'), '조건 데이터 저장 도중 오류가 발생했습니다. 개발 팀에 문의해주세요.');
            } finally {
                this.editLoading = false;
            }
        },
        resetForm() {
            this.form = {
                name: null,
                key: null,
                description: null,
                operator: null,
                value: null,
            };
        },
    },
};
</script>

<style scoped lang="scss">

</style>
